import { ContractRentTemplateFormValues, ContractRentTemplateItemFormValues, ContractSaleTemplateFormValues, ContractSaleTemplateItemFormValues } from "./types";


export const initialContractSaleTemplateForm: ContractSaleTemplateFormValues =
{
  name: "",
  items: [],
};



export const initialContractSaleTemplateItemForm: ContractSaleTemplateItemFormValues =
{
  title: "",
  content: "",
  isNew: false,
  deleted: false,
};


export const initialContractRentTemplateForm: ContractRentTemplateFormValues =
{
  name: "",
  items: [],
};



export const initialContractRentTemplateItemForm: ContractRentTemplateItemFormValues =
{
  title: "",
  content: "",
  isNew: false,
  deleted: false,
};